import { Component, OnInit, ViewChild } from "@angular/core";
import { MyserviceService } from "../../provider/myservice.service";
import Swal from "sweetalert2";
import { ActivatedRoute, Router } from "@angular/router";
import { import_invoice_lang } from "../../language/import_invoice";
import { async } from "@angular/core/testing";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  selector: "app-import-invoice",
  template: `
    <input type="file" (change)="onFileChange($event)" [accept]="'.csv'||'.xlsx'" />
  `,
  templateUrl: "./import-invoice.component.html",
  styleUrls: ["./import-invoice.component.scss"],
})
export class ImportInvoiceComponent implements OnInit {
  showAlert: any;
  municipality = null;
  status_pay: any
  get_import: [];
  lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
  language: any;
  municipality_id;
  showPage = false;
  showSave = false;
  isLoading = true;
  user = JSON.parse(sessionStorage.getItem('user'))
  file: any;
  menu_ = [];
  excel_invoices: any[] = [];
  // file_name:string;
  file_name: string;
  fullname_customer: any;
  showNotification: any;

  json_sheet = null;
  constructor(
    private route: ActivatedRoute,
    router: Router,
    private service: MyserviceService,
    private http: HttpClient,

  ) {
    this.language = import_invoice_lang[this.lang];
  }

  ngOnInit() {
    this.isLoading = false;
    this.municipality_id = JSON.parse(
      sessionStorage.getItem("municipality")
    ).municipality_id;
    this.showPage = true;
    this.route.queryParams.subscribe((params) => {
      this.lang = params["lang"];
      if (this.lang != "EN" && this.lang != "TH") {
        this.lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
        this.language = import_invoice_lang[this.lang];
      } else {
        this.language = import_invoice_lang[this.lang];
        localStorage.setItem("lang", this.lang);
      }
    });
  }

  import_excel() { }

  downloadFile() {
    const path = '/assets/file-excel/แบบฟอร์มขำเข้าข้อมูลใบแจ้งหนี้และใบเสร็จค่าธรรทเนียมขยะ.xlsx';
    const url = window.location.origin + path;
    const options = {
      responseType: 'blob' as 'blob'
    };

    this.http.get(url, options).subscribe(response => {
      const blob = new Blob([response], { type: 'application/octet-stream' });
      const filename = path.split('/').pop();

      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = filename;
      downloadLink.click();

      window.URL.revokeObjectURL(downloadLink.href);
    });
  }

  onFileChange(e_: any) {
    const file = e_.target.files[0];
    const reader: FileReader = new FileReader();

    reader.onload = async (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      // Grab the first worksheet
      const wsname: any = wb.SheetNames;
      //result = ["test1","test2","test3","test4","test5","test6","test7"]
      const a = wsname.reduce((acc, wsname) => {
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        // Convert the worksheet to JSON object
        const arr = XLSX.utils.sheet_to_json(ws, { header: 1 });
        return acc.concat(arr);
      }, []);
      this.json_sheet = a
      console.log(a);
      for (let qq = 0; qq < this.json_sheet.length; qq++) {
        const qq_ = this.json_sheet[qq];
        if (qq_.length == 1) {
          this.json_sheet.splice(qq + 1, 2);
        }
      }
      const community = a.filter(x => x.length == 1);

      console.log(community);

      console.log(this.json_sheet);
      const seenStrings = {};
      const seenStrings_number = {};
      let hasDuplicate = false;
      // this.json_sheet.splice(0, 3);
      // const community = this.json_sheet.splice(0, 3);
      // this.json_sheet.map(e => e.splice(0, 1))
      // console.log(community);
      for (let i = 0; i < this.json_sheet.length; i++) {
        const j = this.json_sheet[i];
        if (typeof j[0] == 'number' && this.json_sheet[i][2]) {
          const stringAtIndex2 = this.json_sheet[i][2].toString();
          const stringAtIndex2_number = this.json_sheet[i][3];
          if (seenStrings[stringAtIndex2] && seenStrings_number[stringAtIndex2_number]) {
            hasDuplicate = true;
            this.json_sheet[i] = null
          } else {
            seenStrings[stringAtIndex2] = true;
            seenStrings_number[stringAtIndex2_number] = true;
          }
        }
        if (typeof j[0] == 'number' && !j[2]) {
          this.json_sheet[i] = null;
        }
        if (j.length == 0) {
          this.json_sheet[i] = null;
        }

      }
      for (let i = 0; i < this.json_sheet.length; i++) {
        const j = this.json_sheet[i];
        if (j) {
          for (let q = 0; q < 41; q++) {
            if (j.length != 1 && q % 2 === 0) {
              if (!this.json_sheet[i][q]) {
                this.json_sheet[i][q] = '-'
                this.json_sheet[i][q + 1] = '-'

              }
              // if ((this.json_sheet[i][q]) && (!this.json_sheet[i][q + 1])) {
              //   this.json_sheet[i][q + 1] = 0
              // }
            }
            if (j.length != 1 && (q - 1) % 3 === 0) {
              if (!this.json_sheet[i][q]) {
                this.json_sheet[i][q] = '-'
                this.json_sheet[i][q + 1] = '-'
              }
            }
            // if (q >= 5 && j[q] != 0 && (q + 1) % 3 === 0) {
            //   if (!j[q]) {
            //     this.json_sheet[i][q] = 0
            //     this.json_sheet[i][q+1] = 0
            //     this.json_sheet[i][q+2] = 0
            //   }
            //   // const date_arr = w[q].split(',')
            //   // if (j[q].split(',')) {
            //   //   const date_arr = j[q].split(',')
            //   //   if (date_arr.length > 1) {
            //   //     date_arr[date_arr.length - 2] + `/${date_arr[date_arr.length - 1].split('/')[3]}`
            //   //     this.json_sheet[i][q][0] + `/${date_arr[date_arr.length - 1].split('/')[3]}}`
            //   //     console.log(this.json_sheet);
            //   //   }
            //   // }

            //   // if (date_arr.length > 1) {
            //   //   console.log(date_arr[date_arr.length]);
            //   // }
            //   // const date = moment(this.json_sheet[i][q], 'DD/MM/YY').toDate()
            //   // this.json_sheet[i][q] = moment(date).format("YYYY-MM-DD HH:mm:ss")
            // }

          }
        }

      }


      this.json_sheet = this.json_sheet.filter(el => el !== null);




      // if (result.data.length === 0) {
      // showAlert = true;
      // csvValue = {
      //   user_name: Value[0],
      //   fee_id: '',
      //   user_id: user,
      //   create_datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
      //   due_date: moment().format("YYYY-MM-DD HH:mm:ss"),
      //   flag: 0,
      //   vat: 0,
      //   vat_rate: 0,
      //   fee_price: 0,
      //   print_count: 0,
      //   total_price: 0,
      //   status_code: this.status_pay,
      //   is_red: true,
      // };
      // } else {
      //   let due_date = moment(Value[4], "YYYY-MM-DD");
      //   if (due_date.format("YYYY") > "2500") { // ถ้าปีเป็น พ.ศ. ให้แปลงเป็น ค.ศ.
      //     due_date = due_date.subtract(543, "years");
      //   }
      //   csvValue = {
      //     user_name: Value[0],
      //     fee_id: result.data[0].fee_id,
      //     user_id: user,
      //     create_datetime: due_date.format("YYYY-MM-DD HH:mm:ss"), // ใช้ due_date ที่แปลงเป็น ค.ศ.
      //     due_date: due_date.format("YYYY-MM-DD HH:mm:ss"), // ใช้ due_date ที่แปลงเป็น ค.ศ.
      //     flag: 1,
      //     vat: 0,
      //     vat_rate: 0,
      //     fee_price: Value[5],
      //     print_count: 0,
      //     total_price: Value[5],
      //     status_code: this.status_pay,
      //   };
      // }
      // this.excel_invoices.push(csvValue);
      // e.target.value = null;
      // });
      // const data = this.json_sheet.map(async (ee: any) => {
      //   const data1 = await ee.map((e_: any, i: number) => {
      //       return e_
      //     // return {
      //     //   name: e_[2] ? e_[2] : 0,
      //     //   October_pay: e_[3] ? e_[3] : 0,
      //     //   October_not_pay: e_[4] ? e_[4] : 0,
      //     //   November_pay: e_[5] ? e_[5] : 0,
      //     //   November_not_pay: e_[6] ? e_[6] : 0,
      //     //   December_pay: e_[7] ? e_[7] : 0,
      //     //   December_not_pay: e_[8] ? e_[8] : 0,
      //     //   January_pay: e_[9] ? e_[9] : 0,
      //     //   January_not_pay: e_[10] ? e_[10] : 0,
      //     //   February_pay: e_[11] ? e_[11] : 0,
      //     //   February_not_pay: e_[12] ? e_[12] : 0,
      //     //   March_pay: e_[13] ? e_[13] : 0,
      //     //   March_not_pay: e_[14] ? e_[14] : 0,
      //     //   April_pay: e_[15] ? e_[15] : 0,
      //     //   April_not_pay: e_[16] ? e_[16] : 0,
      //     //   May_pay: e_[17] ? e_[17] : 0,
      //     //   May_not_pay: e_[18] ? e_[18] : 0,
      //     //   June_pay: e_[19] ? e_[19] : 0,
      //     //   June_not_pay: e_[20] ? e_[20] : 0,
      //     //   July_pay: e_[21] ? e_[21] : 0,
      //     //   July_not_pay: e_[22] ? e_[22] : 0,
      //     //   August_pay: e_[23] ? e_[23] : 0,
      //     //   August_not_pay: e_[24] ? e_[24] : 0,
      //     //   September_pay: e_[25] ? e_[25] : 0,
      //     //   September_not_pay: e_[26] ? e_[26] : 0,
      //     // }
      //   })
      //   return data1
      // })
      // console.log(await Promise.all(data[0]));
      // Download the JSON file
      // const blob = new Blob([JSON.stringify(jsonData)]?e_ta)]:0, { type: 'application/json' });
      // saveAs(blob, 'data.json');
    };

    reader.readAsBinaryString(file);
    // debugger
    // // const file = e.target.files[0];
    // const reader = new FileReader();
    // reader.onload = async () => {
    //   // const data = JSON.parse(reader.result as string);
    //   console.log(reader.result);

    //   // const newdata = await data.features.map((feature: any, i: number) => {
    //   //   feature.user = feature.properties['ชื่อ_สกุล']
    //   //   feature.market_stall_id = feature.properties.NAME;
    //   //   feature.properties.id = feature.properties.ID;
    //   //   feature.market_id = feature.properties.ID
    //   //   feature.number = feature.properties['แผงที่']
    //   //   feature.geometry = JSON.stringify(feature.geometry);
    //   //   feature.properties = JSON.stringify(feature.properties);
    //   //   return feature
    //   // });
    //   // console.log(newdata);

    //   // this.excel_invoices = await Promise.all(newdata);
    // };
    // this.showSave = !this.showSave;
    // reader.readAsText(event.target.files[0]);
    // reader.onerror = function () {
    //   console.log("error is occured while reading file!");
    // };
    // let reader = new FileReader();
    // // if (this.isValidCSVFile(file)) {
    //   reader.readAsText(file);
    //   reader.onload = () => {
    //     console.log(file);
    //     this.file_name = file.name;
    //     let csvData = reader.result;
    //     let csvRecordsArray: string[] = (<string>csvData).split(/\r\n|\n/);
    //     let headersRow = this.getHeaderArray(csvRecordsArray);
    //     console.log(headersRow);
    //     let showAlert = false;
    //     let hasPaidRecords = false;

    //     for (let r = 1; r <= csvRecordsArray.length - 1; r++) {
    //       let Value = csvRecordsArray[r].split(",");
    //       if (Value[0].toString() !== "") {
    //           const user = JSON.parse(sessionStorage.getItem("user")).username;
    //           let fullname = Value[0];
    //           let namesplit = fullname.split(" ");

    //           if (Value[1] === "ยังไม่ชำระ") {
    //             this.status_pay = "01";
    //           } else {
    //             showAlert = true;
    //           }


    //             }
    //           }


    //     if (showAlert) {
    //       this.showAlert = true;
    //     }
    //   };
    //   reader.onerror = function () {
    //     console.log("error is occured while reading file!");
    //   };
    // } else {
    // }
  }



  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(",");
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }

  clear() {
    this.json_sheet = null;
    this.file_name = "";
    this.showSave = false;
  }

  async save() {

    // this.isLoading = true;
    this.isLoading = true;
    this.showPage = false;
    if (this.json_sheet) {
      const res: any = await this.service.postData({ data: this.json_sheet, fiscal_year: '2566', user: this.user.username }, "import/import-invoice")
      if (res.message == 'ok') {
        return Swal.fire({
          title: this.language.save,
          text: "",
          type: "success",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 800,
        }).then((Swal_result) => {
          window.location.reload();
        });
      } else {
        return Swal.fire({
          title: this.language.inform_titlee,
          text: this.language.inform_detaill,
          type: "warning",
          showCancelButton: false,
          confirmButtonColor: "#3085d6",
          confirmButtonText: this.language.confirm,
        }).then(() => {
          this.isLoading = false;

          // this.$router.push('/import_invoice');
        });
      }
    }
    else {
      return Swal.fire({
        title: this.language.inform_title,
        text: this.language.inform_detail,
        type: "warning",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.language.confirm,
      }).then((result) => {
        if (result.value) {
          this.isLoading = false;
          this.showPage = true;
          // Handle action here
        }
      });
    }
  }

  // if (res.message == 'ok') {
  //   Swal.fire({
  //     title: this.language.approve_title,
  //     text: this.language.approve_detail,
  //     type: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: this.language.confirm,
  //     cancelButtonText: this.language.cancel,
  //   }).then((result) => {
  //     if (result.value) {
  //       this.showPage = true;
  //       this.isLoading = false;
  //       this.service
  //         .postData({ invoice: this.excel_invoices }, "import/import-invoice")
  //         .then(
  //           (result: any) => {
  //             if (result.code === false) {
  //               Swal.fire({
  //                 title: this.language.save,
  //                 text: "",
  //                 type: "success",
  //                 showCancelButton: false,
  //                 showConfirmButton: false,
  //                 timer: 800,
  //               }).then((Swal_result) => {
  //                 window.location.reload();
  //               });
  //             } else {
  //               Swal.fire({
  //                 title: this.language.inform_titlee,
  //                 text: this.language.inform_detaill,
  //                 type: "warning",
  //                 showCancelButton: false,
  //                 confirmButtonColor: "#3085d6",
  //                 confirmButtonText: this.language.confirm,
  //               }).then(() => {
  //                 // this.$router.push('/import_invoice');
  //               });
  //             }
  //           },
  //           (err) => {
  //             Swal.fire({
  //               title: this.language.inform_title,
  //               text: "An error occurred while saving the invoice. Please try again later.",
  //               type: "warning",
  //               showCancelButton: false,
  //               confirmButtonColor: "#3085d6",
  //               confirmButtonText: this.language.confirm,
  //             });
  //           }
  //         );
  //     }
  //   });

  // }
}
